
module dg.actions {

    export interface IActionInvokerAttributes extends ng.IAttributes {
        propTemplateUrl: string;
    }

    export abstract class ActionInvokerController {

        public constructor(
            protected $scope: ng.IScope,
            //public formEditor: dg.objects.FormEditorController
        ) {
        }

        public isExecuting: boolean = false;

        public icon: string;
        public title: string;
        public description: string;
        public propTemplateUrl: string;
        public invokeLinks: dg.restfulApi.Link[];
        public form: ng.IFormController;

        public abstract formEditor: dg.objects.FormEditorController;

        public $onInit() {
            //TODO HACK called twice because invoking component and controller from modal
            if (this.binded()) {
                this.title = this.getTitle();
                this.icon = this.getIcon();
                this.description = this.getDescription();
                this.invokeLinks = this.getInvokeLinks();
                if (this.invokeLinks.length == 0) {
                    this.formEditor.disable(true);
                }
                this.init();
            }
        }

        $postLink() {
            this.formEditor.setForm(this.form);
        }

        protected init() {

        }

        //The child should implment custom logic to ensure that bindings are performed
        //Sometimes $onInit is called twice and on the first call bindings are NOT performed
        protected abstract binded(): boolean;

        protected abstract getInvokeLinks(): dg.restfulApi.Link[];

        protected abstract getTitle(): string;

        protected getDescription() {
            return '';
        }

        protected getIcon() {
            return '';
        }

        protected abstract executeAction(executionLink: dg.restfulApi.Link): ng.IPromise<any>;

        //protected preExecute(executionLink: dg.restfulApi.Link): ng.IPromise<any> {

        //}

        protected executeSucceed(successData) {

        }

        protected executeFaild(error) {

        }

        public dismiss() {
            let parentScope: any = this.$scope.$parent;
            if (angular.isFunction(parentScope.$dismiss)) {
                parentScope.$dismiss();
            }
        }

        public execute(executionLink: dg.restfulApi.Link) {
            this.linkExecutionStarted();
            this.formEditor.clearRegisteredErrors();

            this.formEditor.preExecute().then(() => {
                this.executeAction(executionLink).then(successData => {
                    this.executeSucceed(successData);
                    this.linkExecutionEnd();
                    this.dismiss();

                }, this.onExecutionRejected);
            }, this.onExecutionRejected);
        }

        private onExecutionRejected = (error) => {
            this.formEditor.registerError(error);
            this.executeFaild(error);
            this.linkExecutionEnd();
        }


        protected linkExecutionStarted() {
            this.isExecuting = true;
            this.formEditor.disable(true);
        }

        protected linkExecutionEnd() {
            this.isExecuting = false;
            this.formEditor.disable(false);
        };

    }
}